import { ParentBusiness } from "fccore2";
import { CommonService } from "fccore2";

export class FcanyBusiness extends ParentBusiness {
  /**
   * åå§åé»è®¤å¼
   * @param pthis
   * @param context
   */
  static initData(pthis: any, context: any): void {
    pthis.fcPlaceHolder = "è¯·éæ©";
    pthis.fcNotFoundContent = "æªæ¾å°è®°å½";
    pthis.fcLabelCode = "label";
    pthis.fcValueCode = "value";
    pthis._disabledCode = "disabled";
    pthis.fcAutoFocus = "N";
    pthis.fcLineOneSpace = "N";
    pthis.fcType = "tags";
    pthis.fcAutoSize = "Y";
    pthis._autoSize = false;
    /** æ¯å¦æ¯ææ¸é¤ */
    pthis.fcAllowClear = "N";
    pthis._allowClear = false;
    // æ¯å¦é»è®¤æå¼
    pthis.fcOpen = "N";
    pthis._open = false;
    // æ¯å¦å¯ç¨
    pthis._disabled = false;
    pthis.fcDisabled = "N";
    pthis._readonly = false;
    pthis.fcReadonly = "N";
    // é»è®¤æ¥è¯¢ç­ç¥
    pthis.fcFilterOption = (input, option: any) => {
      if (option.nzValue.label && option.nzValue.label.indexOf(input) !== -1) {
        return true;
      } else {
        return false;
      }
    };
  }
  /**
   * æ¹åéé¡¹
   * @param pthis ç»ä»¶å¯¹è±¡
   * @param context åæ°å¯¹è±¡
   */
  static changeOption(pthis: any, context: any): void {
    if (context.fcOption) {
      pthis._options = [];
      if (pthis.fcOption) {
        if (pthis.fcLineOneSpace === "Y") {
          pthis._options.push({ label: "", value: "", disabled: false });
        }
        pthis.fcOption.forEach(element => {
          let el = {
            label:
              pthis.fcLabelCode.indexOf(":{") === -1
                ? element[pthis.fcLabelCode]
                : CommonService.getStringFilterByParam(
                    element,
                    pthis.fcLabelCode
                  ),
            value: element[pthis.fcValueCode],
            disabled: element.disabled
          };
          if (element.hasOwnProperty(pthis.fcDisabledCode)) {
            el.disabled = element[pthis.fcDisabledCode];
          }
          pthis._options.push(el);
        });
      }
    }
  }

  /**
   *
   * @param pthis
   * @param context
   */
  static valueChange(pthis: any, context: any): void {
    let v = pthis._innerValue || { value: undefined };
    let sel = pthis._options.filter(item => {
      return item.value === v.value;
    });
    if (sel.length !== 0) {
      pthis._selectOptions = sel[0];
      let v1 = pthis.innerValue;
      if (v1.value !== v.value) {
        this.valueOnChange(pthis, pthis._selectOptions);
      }
    } else {
      pthis._selectOptions = undefined;
    }
  }
  /**
   * å¼æ¹åå½±åå¤å±è°ç¨
   * @param pthis
   * @param selectOptions
   */
  static valueOnChange(pthis: any, selectOptions: any): void {
    pthis._innerValue = undefined;
    if (selectOptions !== null) {
      let selObj = pthis.fcOption.filter(
        item => item[pthis.fcValueCode] === selectOptions.value
      );
      if (selObj.length !== 0) {
        pthis._innerValue = selObj[0];
      }
    }
    if (pthis._innerValue === "") {
      pthis.event("clear", "");
    }
    pthis.checkValidator(pthis._innerValue);
    pthis.onChangeCallback(pthis._innerValue);
  }
}